<!--
    BadgeMetalPendant 金属徽章
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="挂件 > 金属挂件 > 金属徽章" name="金属徽章">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="badgeMetalPendant " label-width="80px">
              <el-form-item label="边缘色">
                <el-select v-model="badgeMetalPendant ['边缘色']" placeholder="请选">
                  <el-option label="金色" value="金色"></el-option>
                  <el-option label="红铜色" value="红铜色"></el-option>
                  <el-option label="其他选项（请联系客服）" value="其他选项"></el-option>
                </el-select>
                <el-alert
                  title="边缘色&线条颜色&背板颜色,默认以上三个部分颜色统一,其它咨询客服;"
                  type="info"
                  show-icon
                  class="el-alert__title"
                  style="padding: 8px 16px; margin: 20px 0 0 0;"
                ></el-alert>
              </el-form-item>
              <el-form-item label="特殊工艺">
                <el-select v-model="badgeMetalPendant ['特殊工艺']" placeholder="请选特殊工艺">
                  <el-option label="闪粉" value="闪粉"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="配件">
                <el-select v-model="badgeMetalPendant ['配件']" placeholder="请选择配件">
                  <el-option label="龙虾扣" value="龙虾扣"></el-option>
                  <el-option label="手机绳" value="手机绳"></el-option>
                  <el-option label="银色D字扣" value="银色D字扣"></el-option>
                  <el-option label="钥匙圈" value="钥匙圈"></el-option>
                  <el-option label="星星形" value="星星形"></el-option>
                  <el-option label="金色心形" value="金色心形"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="尺寸">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="badgeMetalPendant['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="badgeMetalPendant['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="badgeMetalPendant['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number
                  v-model="badgeMetalPendant['数量']"
                  :min="100"
                  :max="10000"
                  label="数量"
                ></el-input-number>
                <el-alert
                  title="单款起定数为100"
                  type="info"
                  show-icon
                  class="el-alert__title"
                  style="padding: 8px 16px; margin-top:20px;"
                ></el-alert>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button>
              <el-button v-on:click="clear()">清空</el-button>
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "BadgeMetalPendant",
  data() {
    return {
      forcollapse: ["allsame"],
      badgeMetalPendant: {
        title: "金属徽章"
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.badgeMetalPendant);
    },
    clear() {
      this.$root.clearAlert();
      this.badgeMetalPendant = {
        title: "金属徽章"
      };
    }
  }
};
</script>
<style scoped>
</style>